module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Light-9926246b.eot";